import dayjs from 'dayjs'

import { formatTime } from './date-utils'

/** From the nex 10 days returns an array of dates excluding weekend days */

export type Slot = [Date, Date]

const addMinutes = (date: Date, duration: number) => {
  return dayjs(date).add(duration, 'minutes').toDate()
}

const slotMaker = (slots: Slot[], slotDurationMin: number, slotLimit: Date): Slot[] => {
  if (slots.length === 0) return []
  const [, end] = slots[slots.length - 1]
  if (addMinutes(end, slotDurationMin).getTime() > slotLimit.getTime()) return slots
  const nextSlots: Slot[] = [...slots, [end, addMinutes(end, slotDurationMin)]]
  return slotMaker(nextSlots, slotDurationMin, slotLimit)
}

export const getSlotsFromDate = (d: Date, excludeLunch: boolean = false): Slot[] => {
  const slotDuration = 60
  const limit = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 18, 0, 0)

  const startSlot: Slot[] = [
    ...(addMinutes(d, slotDuration) <= limit ? ([[d, addMinutes(d, slotDuration)]] as Slot[]) : []),
  ]
  const slots = slotMaker(startSlot, slotDuration, limit)
  if (!excludeLunch) return slots

  return slots.filter((slot) => {
    if (slot[0].getHours() === 13) return false
    return true
  })
}

export const mapSlotToLabelValue = (ds: Slot[]) =>
  ds.map((value) => {
    const [start, end] = value
    const label = `${start.getHours()} - ${end.getHours()}`
    return {
      label,
      value: label,
    }
  })

export const mapAvailableSchedulingTimeSlot = (ds: Slot[]) => ds.map(fromSlotToDateValues)

export const fromSlotToDateValues = (slot: Slot) => {
  const [from, to] = slot
  const label = `${formatTime(from)} ${formatTime(to)}`
  return {
    label,
    slots: slot,
    value: `${formatTime(from)}-${formatTime(to)}`,
  }
}
